"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeNoDataRgba;
function makeNoDataRgba(noDataValue) {
  // typescript not smart enough to realize all values in the array will be the same
  // @ts-ignore
  return [noDataValue, noDataValue, noDataValue, 0];
}